import { toast } from "react-toastify";

export const isValidImage = (url) => {
  return url && !url.includes("https://example.com");
};

export const PERPAGE_RECORD = 10;

export const showToast = (message, success) => {
  success ? toast.success(message) : toast.error(message);
};
